/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {
  var context = window.BathhouseClarityContext || {};
  var identifyRetries = 0;
  var maxIdentifyRetries = 60;
  var bridgeSyncTimeout = null;
  var lastBridgePayload = '';
  var lastKnownCart = null;
  var pageEnterTimestamp = Date.now();
  var maxScrollDepth = 0;
  var trackedScrollMilestones = {};
  var POSTHOG_PROJECT_TOKEN = 'phc_uEqUreHMVSa57Pmmtv43hk22MgfadkmAsSNKyrNo6tJH';
  var POSTHOG_API_HOST = 'https://us.i.posthog.com';
  var POSTHOG_UI_HOST = 'https://us.posthog.com';

  function safeString(value) {
    if (value === null || value === undefined) return '';
    return String(value).trim();
  }

  function firstNonEmpty(values) {
    for (var i = 0; i < values.length; i += 1) {
      var candidate = safeString(values[i]);
      if (candidate) return candidate;
    }
    return '';
  }

  function ensureStorageBackedId(storage, primaryKey, legacyKey, fallbackPrefix) {
    var existing = '';

    try {
      existing = safeString(storage.getItem(primaryKey));
      if (!existing && legacyKey) {
        existing = safeString(storage.getItem(legacyKey));
      }
      if (!existing) {
        existing = window.crypto && typeof window.crypto.randomUUID === 'function'
          ? window.crypto.randomUUID()
          : fallbackPrefix + '-' + Date.now() + '-' + Math.floor(Math.random() * 1000000);
      }
      storage.setItem(primaryKey, existing);
      if (legacyKey) storage.setItem(legacyKey, existing);
    } catch (error) {
      existing = fallbackPrefix + '-memory';
    }

    return existing;
  }

  function ensurePersistentVisitorId() {
    return ensureStorageBackedId(window.localStorage, 'bathhouse_visitor_id', 'bathhouse_clarity_visitor_id', 'bhv');
  }

  function ensureSessionId() {
    return ensureStorageBackedId(window.sessionStorage, 'bathhouse_session_id', 'bathhouse_clarity_session_id', 'bhs');
  }

  function ensureLandingPath() {
    var storageKey = 'bathhouse_landing_path';
    var existing = '';

    try {
      existing = safeString(window.sessionStorage.getItem(storageKey));
      if (!existing) {
        existing = safeString(window.location.pathname) || '/';
        window.sessionStorage.setItem(storageKey, existing);
      }
    } catch (error) {
      existing = safeString(window.location.pathname) || '/';
    }

    return existing;
  }

  function getReferrerHost() {
    try {
      return document.referrer ? new URL(document.referrer).hostname : 'direct_or_unknown';
    } catch (error) {
      return 'direct_or_unknown';
    }
  }

  function getCustomerLifecycleStage() {
    var orderCount = Number(context.customerOrdersCount);
    if (!context.customerId) return 'guest_or_unknown';
    if (!Number.isFinite(orderCount) || orderCount <= 0) return 'logged_in_unknown_order_history';
    if (orderCount === 1) return 'first_order_known_customer';
    return 'repeat_known_customer';
  }

  function getPageId() {
    var resourceHandle = safeString(context.resourceHandle);
    var pageType = firstNonEmpty([context.pageType, 'unknown']);
    var pathname = safeString(window.location.pathname).replace(/[^a-zA-Z0-9/_-]/g, '');
    return firstNonEmpty([
      resourceHandle ? pageType + ':' + resourceHandle : '',
      pathname ? 'path:' + pathname : '',
      pageType
    ]);
  }

  function getFriendlyName() {
    return firstNonEmpty([
      context.resourceTitle,
      context.resourceHandle,
      document.title,
      context.pageType
    ]);
  }

  function getUrlObject(value) {
    var normalizedValue = safeString(value);
    if (!normalizedValue) return null;

    try {
      return new URL(normalizedValue, window.location.origin);
    } catch (error) {
      return null;
    }
  }

  function getUtmProperties(urlObject) {
    var source = urlObject || getUrlObject(window.location.href);
    var searchParams = source && source.searchParams ? source.searchParams : null;

    return {
      utm_source: searchParams ? safeString(searchParams.get('utm_source')) : '',
      utm_medium: searchParams ? safeString(searchParams.get('utm_medium')) : '',
      utm_campaign: searchParams ? safeString(searchParams.get('utm_campaign')) : '',
      utm_content: searchParams ? safeString(searchParams.get('utm_content')) : '',
      utm_term: searchParams ? safeString(searchParams.get('utm_term')) : ''
    };
  }

  function getSectionContext(element) {
    var section = element && element.closest ? element.closest('.shopify-section, [data-section-id], section[id]') : null;
    return {
      section_id: safeString(section && (section.getAttribute('data-section-id') || section.id)),
      section_class: safeString(section && section.className)
    };
  }

  function getClickProperties(target) {
    var href = target && target.getAttribute ? safeString(target.getAttribute('href')) : '';
    var urlObject = getUrlObject(href);
    var path = safeString(urlObject && urlObject.pathname);
    var productMatch = path.match(/\/products\/([^/?#]+)/);
    var collectionMatch = path.match(/\/collections\/([^/?#]+)/);
    var isButton = !!(target && target.tagName === 'BUTTON');
    var base = {
      click_text: safeString(target && target.textContent).replace(/\s+/g, ' ').slice(0, 140),
      click_href: href,
      click_path: path,
      click_id: safeString(target && target.id),
      click_classes: safeString(target && target.className),
      link_type: isButton ? 'button' : (href ? 'link' : 'control'),
      destination_product_handle: productMatch ? productMatch[1] : '',
      destination_collection_handle: collectionMatch ? collectionMatch[1] : ''
    };
    var sectionContext = getSectionContext(target);
    var utm = getUtmProperties(urlObject);

    for (var key in sectionContext) {
      if (Object.prototype.hasOwnProperty.call(sectionContext, key)) {
        base[key] = sectionContext[key];
      }
    }

    for (var utmKey in utm) {
      if (Object.prototype.hasOwnProperty.call(utm, utmKey)) {
        base[utmKey] = utm[utmKey];
      }
    }

    return base;
  }

  function getClosestProductHandle(target) {
    if (!target || !target.closest) return '';

    var productRoot = target.closest('[data-product-handle], [data-product-url], [data-product-item], [data-product], .product-grid-item, .product-item, [data-product-grid-item]');
    var explicitHandle = safeString(productRoot && productRoot.getAttribute && productRoot.getAttribute('data-product-handle'));
    if (explicitHandle) return explicitHandle;

    var explicitUrl = safeString(productRoot && productRoot.getAttribute && productRoot.getAttribute('data-product-url'));
    var explicitUrlMatch = explicitUrl.match(/\/products\/([^/?#]+)/);
    if (explicitUrlMatch) return explicitUrlMatch[1];

    var productLink = productRoot && productRoot.querySelector
      ? productRoot.querySelector('a[href*="/products/"]')
      : null;
    var href = safeString(productLink && productLink.getAttribute && productLink.getAttribute('href'));
    var hrefMatch = href.match(/\/products\/([^/?#]+)/);
    if (hrefMatch) return hrefMatch[1];

    return '';
  }

  function readSessionPathHistory() {
    var storageKey = 'bathhouse_session_path_history';
    try {
      var raw = window.sessionStorage.getItem(storageKey);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function writeSessionPathHistory(paths) {
    try {
      window.sessionStorage.setItem('bathhouse_session_path_history', JSON.stringify(paths.slice(-12)));
    } catch (error) {}
  }

  function getControlProperties(target) {
    var properties = getClickProperties(target);
    var text = properties.click_text.toLowerCase();

    properties.control_name = safeString(target && target.getAttribute && target.getAttribute('name'));
    properties.control_role = safeString(target && target.getAttribute && target.getAttribute('role'));
    properties.control_for = safeString(target && target.getAttribute && target.getAttribute('for'));
    properties.control_aria_controls = safeString(target && target.getAttribute && target.getAttribute('aria-controls'));
    properties.control_data_drawer = safeString(target && target.getAttribute && target.getAttribute('data-drawer-toggle'));
    properties.control_data_popdown = safeString(target && target.getAttribute && target.getAttribute('data-popdown-toggle'));
    properties.control_data_accordion = safeString(target && target.getAttribute && target.getAttribute('data-accordion-trigger'));
    properties.control_label_hint =
      text.indexOf('ingredient') >= 0 ? 'ingredients' :
      text.indexOf('description') >= 0 ? 'description' :
      text.indexOf('read more') >= 0 || text === 'more' || text.indexOf('show more') >= 0 ? 'more' :
      text.indexOf('details') >= 0 ? 'details' :
      '';

    return properties;
  }

  function getSidebarProperties(target) {
    var group = target && target.closest ? target.closest('.sidebar__filter__group') : null;
    var heading = group ? group.querySelector('.sidebar__heading span, .sidebar__heading') : null;
    var properties = getControlProperties(target);
    properties.sidebar_group_title = safeString(heading && heading.textContent);
    properties.in_sidebar_filters = !!group;
    return properties;
  }

  function getViewportProperties() {
    return {
      viewport_width: window.innerWidth || null,
      viewport_height: window.innerHeight || null,
      screen_width: window.screen && window.screen.width ? window.screen.width : null,
      screen_height: window.screen && window.screen.height ? window.screen.height : null
    };
  }

  function getScrollDepthPercent() {
    var doc = document.documentElement || document.body;
    if (!doc) return 0;

    var scrollTop = window.pageYOffset || doc.scrollTop || 0;
    var viewportHeight = window.innerHeight || doc.clientHeight || 0;
    var scrollHeight = Math.max(doc.scrollHeight || 0, document.body ? document.body.scrollHeight || 0 : 0);
    var denominator = scrollHeight - viewportHeight;

    if (denominator <= 0) return 100;

    return Math.max(0, Math.min(100, Math.round(((scrollTop + viewportHeight) / scrollHeight) * 100)));
  }

  function getEventMetadata(name) {
    var normalizedName = safeString(name);
    var defaults = {
      bathhouse_event_tier: 'behavior_support',
      bathhouse_event_stage: 'browse',
      bathhouse_business_action: 'supporting_behavior'
    };
    var metadata = {
      bathhouse_page_view: { bathhouse_event_tier: 'core_funnel', bathhouse_event_stage: 'browse', bathhouse_business_action: 'page_view' },
      bathhouse_homepage_view: { bathhouse_event_tier: 'core_funnel', bathhouse_event_stage: 'browse', bathhouse_business_action: 'homepage_view' },
      bathhouse_not_found_view: { bathhouse_event_tier: 'core_funnel', bathhouse_event_stage: 'browse', bathhouse_business_action: 'not_found_view' },
      bathhouse_collection_view: { bathhouse_event_tier: 'core_funnel', bathhouse_event_stage: 'browse', bathhouse_business_action: 'collection_view' },
      bathhouse_product_view: { bathhouse_event_tier: 'core_funnel', bathhouse_event_stage: 'browse', bathhouse_business_action: 'product_view' },
      bathhouse_cart_view: { bathhouse_event_tier: 'core_funnel', bathhouse_event_stage: 'cart', bathhouse_business_action: 'cart_view' },
      bathhouse_search_submit: { bathhouse_event_tier: 'core_funnel', bathhouse_event_stage: 'browse', bathhouse_business_action: 'search_submit' },
      bathhouse_add_to_cart: { bathhouse_event_tier: 'core_funnel', bathhouse_event_stage: 'cart', bathhouse_business_action: 'add_to_cart' },
      bathhouse_remove_from_cart: { bathhouse_event_tier: 'core_funnel', bathhouse_event_stage: 'cart', bathhouse_business_action: 'remove_from_cart' },
      bathhouse_checkout_started: { bathhouse_event_tier: 'core_funnel', bathhouse_event_stage: 'checkout', bathhouse_business_action: 'checkout_started' },
      bathhouse_shipping_info_submitted: { bathhouse_event_tier: 'core_funnel', bathhouse_event_stage: 'checkout', bathhouse_business_action: 'shipping_info_submitted' },
      bathhouse_payment_info_submitted: { bathhouse_event_tier: 'core_funnel', bathhouse_event_stage: 'checkout', bathhouse_business_action: 'payment_info_submitted' },
      bathhouse_purchase: { bathhouse_event_tier: 'core_funnel', bathhouse_event_stage: 'purchase', bathhouse_business_action: 'purchase' },
      bathhouse_add_to_cart_click: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'browse', bathhouse_business_action: 'add_to_cart_click' },
      bathhouse_checkout_button_click: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'cart', bathhouse_business_action: 'checkout_button_click' },
      bathhouse_variant_change: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'browse', bathhouse_business_action: 'variant_change' },
      bathhouse_cart_change: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'cart', bathhouse_business_action: 'cart_change' },
      bathhouse_cart_revisit: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'cart', bathhouse_business_action: 'cart_revisit' },
      bathhouse_return_to_browse_after_cart: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'browse', bathhouse_business_action: 'return_to_browse_after_cart' },
      bathhouse_search_results_view: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'browse', bathhouse_business_action: 'search_results_view' },
      bathhouse_search_no_results_view: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'browse', bathhouse_business_action: 'search_no_results_view' },
      bathhouse_search_result_click: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'browse', bathhouse_business_action: 'search_result_click' },
      bathhouse_search_focus: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'browse', bathhouse_business_action: 'search_focus' },
      bathhouse_collection_filter_toggle: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'browse', bathhouse_business_action: 'collection_filter_toggle' },
      bathhouse_collection_filter_apply: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'browse', bathhouse_business_action: 'collection_filter_apply' },
      bathhouse_parent_collection_filter_apply: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'browse', bathhouse_business_action: 'parent_collection_filter_apply' },
      bathhouse_child_collection_filter_select: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'browse', bathhouse_business_action: 'child_collection_filter_select' },
      bathhouse_collection_layout_toggle: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'browse', bathhouse_business_action: 'collection_layout_toggle' },
      bathhouse_product_link_click: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'browse', bathhouse_business_action: 'product_link_click' },
      bathhouse_collection_link_click: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'browse', bathhouse_business_action: 'collection_link_click' },
      bathhouse_navigation_click: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'browse', bathhouse_business_action: 'navigation_click' },
      bathhouse_home_logo_click: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'browse', bathhouse_business_action: 'home_logo_click' },
      bathhouse_drawer_toggle: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'browse', bathhouse_business_action: 'drawer_toggle' },
      bathhouse_popdown_toggle: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'browse', bathhouse_business_action: 'popdown_toggle' },
      bathhouse_accordion_toggle: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'browse', bathhouse_business_action: 'accordion_toggle' },
      bathhouse_details_toggle: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'browse', bathhouse_business_action: 'details_toggle' },
      bathhouse_tab_click: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'browse', bathhouse_business_action: 'tab_click' },
      bathhouse_read_more_toggle: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'browse', bathhouse_business_action: 'read_more_toggle' },
      bathhouse_content_cta_click: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'browse', bathhouse_business_action: 'content_cta_click' },
      bathhouse_website_services_inquiry_started: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'lead', bathhouse_business_action: 'lead_form_started' },
      bathhouse_website_services_inquiry_submit_attempted: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'lead', bathhouse_business_action: 'lead_form_submit_attempted' },
      bathhouse_website_services_inquiry_submitted: { bathhouse_event_tier: 'core_funnel', bathhouse_event_stage: 'lead', bathhouse_business_action: 'lead_form_submitted' },
      bathhouse_website_services_inquiry_error: { bathhouse_event_tier: 'behavior_support', bathhouse_event_stage: 'lead', bathhouse_business_action: 'lead_form_error' },
      bathhouse_scroll_depth: { bathhouse_event_tier: 'engagement_signal', bathhouse_event_stage: 'engagement', bathhouse_business_action: 'scroll_depth' },
      bathhouse_page_exit: { bathhouse_event_tier: 'engagement_signal', bathhouse_event_stage: 'engagement', bathhouse_business_action: 'page_exit' }
    };

    return metadata[normalizedName] || defaults;
  }

  function withClarity(callback) {
    if (typeof window.clarity === 'function') {
      callback(window.clarity);
      return true;
    }
    return false;
  }

  function initPostHog() {
    if (!safeString(POSTHOG_PROJECT_TOKEN) || safeString(POSTHOG_PROJECT_TOKEN).indexOf('phc_') !== 0) {
      return false;
    }

    !function(t, e) {
      var o, n, p, r;
      if (e.__SV) return;
      window.posthog = e;
      e._i = [];
      e.init = function(i, s, a) {
        function g(t, e) {
          var o = e.split('.');
          if (o.length === 2) {
            t = t[o[0]];
            e = o[1];
          }
          t[e] = function() {
            t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
          };
        }
        p = t.createElement('script');
        p.type = 'text/javascript';
        p.async = true;
        p.crossOrigin = 'anonymous';
        p.src = s.api_host.replace('.i.posthog.com', '-assets.i.posthog.com') + '/static/array.js';
        r = t.getElementsByTagName('script')[0];
        r.parentNode.insertBefore(p, r);
        var u = e;
        if (a !== undefined) {
          u = e[a] = [];
        } else {
          a = 'posthog';
        }
        u.people = u.people || [];
        u.toString = function(t) {
          var e = 'posthog';
          if (a !== 'posthog') e += '.' + a;
          if (!t) e += ' (stub)';
          return e;
        };
        u.people.toString = function() {
          return u.toString(1) + '.people (stub)';
        };
        o = 'capture identify alias people.set people.set_once register register_once unregister reset opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing startSessionRecording stopSessionRecording sessionRecordingStarted setPersonProperties setPersonPropertiesOnce group identifyGroup setGroupProperties setGroupPropertiesOnce captureException'.split(' ');
        for (n = 0; n < o.length; n += 1) {
          g(u, o[n]);
        }
        e._i.push([i, s, a]);
      };
      e.__SV = 1;
    }(document, window.posthog || []);

    window.posthog.init(POSTHOG_PROJECT_TOKEN, {
      api_host: POSTHOG_API_HOST,
      ui_host: POSTHOG_UI_HOST,
      defaults: '2026-01-30',
      autocapture: true,
      capture_pageview: false,
      capture_pageleave: true,
      capture_dead_clicks: true,
      disable_surveys: true,
      person_profiles: 'identified_only'
    });

    return true;
  }

  function withPostHog(callback) {
    if (window.posthog && typeof window.posthog.capture === 'function') {
      callback(window.posthog);
      return true;
    }
    return false;
  }

  function identifyClarity() {
    var customId = firstNonEmpty([
      context.customerId ? 'customer:' + context.customerId : '',
      'visitor:' + ensurePersistentVisitorId()
    ]);
    var sessionId = 'session:' + ensureSessionId();
    var pageId = getPageId();
    var friendlyName = getFriendlyName();

    return withClarity(function(clarity) {
      clarity('identify', customId, sessionId, pageId, friendlyName);
    });
  }

  function buildTrackingProperties(extra) {
    var bridge = buildBridgeAttributes(lastKnownCart);
    var properties = {
      shop_name: safeString(context.shopName),
      page_type: safeString(context.pageType),
      surface_type: safeString(context.surfaceType),
      template_name: safeString(context.templateName),
      template_suffix: safeString(context.templateSuffix),
      locale: safeString(context.locale),
      currency_code: safeString(context.currencyCode),
      shopify_customer_id: safeString(context.customerId),
      customer_order_count: safeString(context.customerOrdersCount),
      customer_state: context.customerId ? 'logged_in' : 'guest',
      customer_lifecycle_stage: getCustomerLifecycleStage(),
      resource_handle: safeString(context.resourceHandle),
      resource_id: safeString(context.resourceId),
      resource_title: safeString(context.resourceTitle),
      product_handle: safeString(context.productHandle),
      collection_handle: safeString(context.collectionHandle),
      article_handle: safeString(context.articleHandle),
      blog_handle: safeString(context.blogHandle),
      page_handle: safeString(context.pageHandle),
      search_terms: safeString(context.searchTerms),
      cart_item_count: safeString(context.cartItemCount),
      cart_total_cents: safeString(context.cartTotalCents),
      path: safeString(window.location.pathname) || '/',
      page_url: safeString(window.location.href),
      page_title: safeString(document.title),
      query_string: safeString(window.location.search),
      referrer_host: getReferrerHost(),
      page_time_on_page_ms: Date.now() - pageEnterTimestamp,
      page_scroll_depth_percent: maxScrollDepth,
      bathhouse_bridge_version: bridge.bathhouse_bridge_version,
      bathhouse_visitor_id: bridge.bathhouse_visitor_id,
      bathhouse_session_id: bridge.bathhouse_session_id,
      bathhouse_landing_path: bridge.bathhouse_landing_path,
      bathhouse_last_path: bridge.bathhouse_last_path,
      bathhouse_last_product_handle: bridge.bathhouse_last_product_handle,
      bathhouse_cart_handles: bridge.bathhouse_cart_handles,
      bathhouse_referrer_host: bridge.bathhouse_referrer_host,
      bathhouse_customer_state: bridge.bathhouse_customer_state
    };
    var utmProperties = getUtmProperties();
    var viewportProperties = getViewportProperties();

    for (var utmKey in utmProperties) {
      if (Object.prototype.hasOwnProperty.call(utmProperties, utmKey)) {
        properties[utmKey] = utmProperties[utmKey];
      }
    }

    for (var viewportKey in viewportProperties) {
      if (Object.prototype.hasOwnProperty.call(viewportProperties, viewportKey)) {
        properties[viewportKey] = viewportProperties[viewportKey];
      }
    }

    if (extra) {
      for (var key in extra) {
        if (Object.prototype.hasOwnProperty.call(extra, key)) {
          properties[key] = extra[key];
        }
      }
    }

    return properties;
  }

  function syncPostHogState() {
    withPostHog(function(posthog) {
      var properties = buildTrackingProperties();
      posthog.register(properties);
      if (typeof posthog.startSessionRecording === 'function') {
        posthog.startSessionRecording();
      }

      if (context.customerId) {
        posthog.identify('customer:' + String(context.customerId), {
          shopify_customer_id: String(context.customerId),
          customer_order_count: safeString(context.customerOrdersCount),
          customer_lifecycle_stage: getCustomerLifecycleStage(),
          customer_state: 'logged_in',
          locale: safeString(context.locale),
          currency_code: safeString(context.currencyCode)
        });
      }
    });
  }

  function capturePostHogEvent(name, properties) {
    var normalizedName = safeString(name);
    if (!normalizedName) return;

    withPostHog(function(posthog) {
      var payload = buildTrackingProperties(properties);
      var metadata = getEventMetadata(normalizedName);

      for (var key in metadata) {
        if (Object.prototype.hasOwnProperty.call(metadata, key) && typeof payload[key] === 'undefined') {
          payload[key] = metadata[key];
        }
      }

      posthog.capture(normalizedName, payload);
    });
  }

  function capturePostHogPageview() {
    capturePostHogEvent('$pageview', {
      current_url: safeString(window.location.href),
      pathname: safeString(window.location.pathname),
      title: safeString(document.title)
    });

    capturePostHogEvent('bathhouse_page_view', {
      surface_origin: 'theme'
    });
  }

  function retryIdentify() {
    if (identifyClarity()) return;
    if (identifyRetries >= maxIdentifyRetries) return;
    identifyRetries += 1;
    window.setTimeout(retryIdentify, 1000);
  }

  function setTag(key, value) {
    var normalizedKey = safeString(key);
    if (!normalizedKey) return;

    var normalizedValue = Array.isArray(value)
      ? value.map(function(entry) { return safeString(entry); }).filter(Boolean)
      : safeString(value);

    if ((Array.isArray(normalizedValue) && normalizedValue.length === 0) || (!Array.isArray(normalizedValue) && !normalizedValue)) {
      return;
    }

    withClarity(function(clarity) {
      clarity('set', normalizedKey, normalizedValue);
    });
  }

  function trackEvent(name) {
    var normalizedName = safeString(name);
    if (!normalizedName) return;

    withClarity(function(clarity) {
      clarity('event', normalizedName);
    });
  }

  function trackBathhouseEvent(name, properties) {
    var normalizedName = safeString(name);
    if (!normalizedName) return;
    trackEvent('bathhouse_' + normalizedName);
    capturePostHogEvent('bathhouse_' + normalizedName, properties);
  }

  function upgradeSession(reason) {
    var normalizedReason = safeString(reason);
    if (!normalizedReason) return;

    withClarity(function(clarity) {
      clarity('upgrade', normalizedReason);
    });
  }

  function applyBaseTags() {
    setTag('page_type', context.pageType);
    setTag('surface_type', context.surfaceType);
    setTag('template_name', context.templateName);
    setTag('template_suffix', context.templateSuffix);
    setTag('locale', context.locale);
    setTag('currency_code', context.currencyCode);
    setTag('customer_order_count', context.customerOrdersCount);
    setTag('customer_lifecycle_stage', getCustomerLifecycleStage());
    setTag('resource_handle', context.resourceHandle);
    setTag('resource_title', context.resourceTitle);
    setTag('product_handle', context.productHandle);
    setTag('collection_handle', context.collectionHandle);
    setTag('article_handle', context.articleHandle);
    setTag('blog_handle', context.blogHandle);
    setTag('page_handle', context.pageHandle);
    setTag('search_terms', context.searchTerms);
    setTag('cart_item_count', context.cartItemCount);
    setTag('cart_total_cents', context.cartTotalCents);
    setTag('path', window.location.pathname);
    setTag('referrer_host', getReferrerHost());
    setTag('customer_state', context.customerId ? 'logged_in' : 'guest');

    if (context.pageType === 'product') {
      trackBathhouseEvent('product_view');
      upgradeSession('product_page_view');
    }

    if (context.pageType === 'cart') {
      trackBathhouseEvent('cart_view');
      upgradeSession('cart_page_view');
    }

    if (context.pageType === 'search' && context.searchTerms) {
      var searchResultsCount = Number(context.searchResultsCount);
      var searchProperties = {
        search_terms: safeString(context.searchTerms),
        search_results_count: Number.isFinite(searchResultsCount) ? searchResultsCount : null
      };

      trackBathhouseEvent('search_results_view', searchProperties);
      if (searchResultsCount === 0) {
        trackBathhouseEvent('search_no_results_view', searchProperties);
      }
      upgradeSession('search_results_view');
    }

    if (context.pageType === 'collection') {
      trackBathhouseEvent('collection_view');
    }

    if (context.pageType === 'index') {
      trackBathhouseEvent('homepage_view');
    }

    if (context.pageType === '404') {
      trackBathhouseEvent('not_found_view', {
        not_found_path: safeString(window.location.pathname),
        not_found_referrer: safeString(document.referrer)
      });
      upgradeSession('not_found_view');
    }
  }

  function tagProductContext(variant) {
    var variantId = variant && variant.id ? String(variant.id) : '';
    var variantTitle = variant && variant.title ? String(variant.title) : '';
    var variantAvailable = variant && typeof variant.available !== 'undefined' ? String(Boolean(variant.available)) : '';

    setTag('selected_variant_id', variantId);
    setTag('selected_variant_title', variantTitle);
    setTag('selected_variant_available', variantAvailable);
  }

  function tagCartContext(cart) {
    if (!cart) return;

    lastKnownCart = cart;

    setTag('cart_item_count', typeof cart.item_count !== 'undefined' ? String(cart.item_count) : '');
    setTag('cart_total_cents', typeof cart.total_price !== 'undefined' ? String(cart.total_price) : '');

    if (Array.isArray(cart.items)) {
      var handles = cart.items
        .map(function(item) {
          if (item && item.product_handle) return safeString(item.product_handle);
          if (item && item.url) {
            var match = String(item.url).match(/\/products\/([^/?#]+)/);
            return match ? match[1] : '';
          }
          return '';
        })
        .filter(Boolean);

      setTag('cart_handles', handles.slice(0, 10));
    }
  }

  function buildBridgeAttributes(cart) {
    var handles = [];
    if (cart && Array.isArray(cart.items)) {
      handles = cart.items
        .map(function(item) {
          if (item && item.product_handle) return safeString(item.product_handle);
          if (item && item.url) {
            var match = String(item.url).match(/\/products\/([^/?#]+)/);
            return match ? match[1] : '';
          }
          return '';
        })
        .filter(Boolean)
        .slice(0, 5);
    }

    return {
      bathhouse_bridge_version: '1',
      bathhouse_visitor_id: ensurePersistentVisitorId(),
      bathhouse_session_id: ensureSessionId(),
      bathhouse_landing_path: ensureLandingPath(),
      bathhouse_last_path: safeString(window.location.pathname) || '/',
      bathhouse_last_product_handle: firstNonEmpty([context.productHandle, context.resourceHandle]),
      bathhouse_cart_handles: handles.join(','),
      bathhouse_referrer_host: getReferrerHost(),
      bathhouse_customer_state: context.customerId ? 'logged_in' : 'guest',
      bathhouse_customer_lifecycle_stage: getCustomerLifecycleStage()
    };
  }

  function syncCartBridgeAttributes(cart) {
    var attributes = buildBridgeAttributes(cart);
    var payload = JSON.stringify({ attributes: attributes });
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';

    if (payload === lastBridgePayload) return;
    lastBridgePayload = payload;

    fetch(root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: payload
    }).then(function(response) {
      if (!response.ok) {
        lastBridgePayload = '';
      }
    }).catch(function() {
      lastBridgePayload = '';
    });
  }

  function queueCartBridgeSync(cart) {
    if (bridgeSyncTimeout) {
      window.clearTimeout(bridgeSyncTimeout);
    }

    bridgeSyncTimeout = window.setTimeout(function() {
      syncCartBridgeAttributes(cart);
    }, 300);
  }

  function observeSearch() {
    document.addEventListener('submit', function(event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;

      var searchInput = form.querySelector('input[name="q"]');
      if (!searchInput) return;

      var searchTerms = safeString(searchInput.value);
      if (!searchTerms) return;

      setTag('search_terms', searchTerms);
      trackBathhouseEvent('search_submit', { search_terms: searchTerms });
      upgradeSession('search_submit');
    }, true);
  }

  function observeCheckoutIntent() {
    document.addEventListener('click', function(event) {
      var trigger = event.target && event.target.closest
        ? event.target.closest('button[name="checkout"], input[name="checkout"], [href$="/checkout"], .checkout__button')
        : null;

      if (!trigger) return;

      trackBathhouseEvent('checkout_button_click', getClickProperties(trigger));
      upgradeSession('checkout_attempt');
    }, true);
  }

  function observeAddToCartIntent() {
    document.addEventListener('click', function(event) {
      var trigger = event.target && event.target.closest
        ? event.target.closest('[name="add"], [data-add-to-cart], [data-variant-id]')
        : null;

      if (!trigger) return;

      var properties = getClickProperties(trigger);
      properties.trigger_name = safeString(trigger.getAttribute('name'));
      properties.trigger_variant_id = safeString(trigger.getAttribute('data-variant-id'));
      properties.product_handle = firstNonEmpty([
        properties.destination_product_handle,
        safeString(context.productHandle),
        getClosestProductHandle(trigger)
      ]);
      properties.collection_handle = firstNonEmpty([
        safeString(context.collectionHandle),
        properties.destination_collection_handle
      ]);
      properties.source_surface_type = safeString(context.surfaceType);
      trackBathhouseEvent('add_to_cart_click', properties);
      upgradeSession('add_to_cart_click');
    }, true);
  }

  function observeJourneyLoopSignals() {
    var currentPath = safeString(window.location.pathname) || '/';
    var history = readSessionPathHistory();
    var previousPath = history.length ? history[history.length - 1] : '';
    var priorCartVisits = history.filter(function(path) { return path === '/cart'; }).length;

    if (currentPath === '/cart' && priorCartVisits >= 1) {
      trackBathhouseEvent('cart_revisit', {
        previous_path: previousPath,
        cart_visit_count: String(priorCartVisits + 1)
      });
    }

    if (currentPath !== '/cart' && previousPath === '/cart') {
      trackBathhouseEvent('return_to_browse_after_cart', {
        previous_path: previousPath,
        returned_path: currentPath,
        prior_cart_visits: String(priorCartVisits)
      });
    }

    history.push(currentPath);
    writeSessionPathHistory(history);
  }

  function observeCollectionAndFilterIntent() {
    document.addEventListener('click', function(event) {
      var target = event.target && event.target.closest ? event.target.closest('[data-filters-toggle], [data-filter-update-url], [data-toggle-grid], [data-collection-tools] select') : null;
      if (!target) return;

      if (target.hasAttribute('data-filters-toggle')) {
        trackBathhouseEvent('collection_filter_toggle');
        return;
      }

      if (target.hasAttribute('data-filter-update-url')) {
        trackBathhouseEvent('collection_filter_apply', {
          filter_url: safeString(target.getAttribute('data-filter-update-url'))
        });
        return;
      }

      if (target.hasAttribute('data-toggle-grid')) {
        trackBathhouseEvent('collection_layout_toggle');
      }
    }, true);

    document.addEventListener('change', function(event) {
      var target = event.target;
      if (!target || !target.closest) return;

      if (target.matches('[data-child-filter-select], .collection-child-filters__select')) {
        var filterRoot = target.closest('[data-child-filter-root], .collection-child-filters');
        var selectedOption = target.options && target.selectedIndex >= 0 ? target.options[target.selectedIndex] : null;
        trackBathhouseEvent('child_collection_filter_select', {
          filter_name: 'child_collection',
          filter_value: safeString(target.value),
          filter_label: safeString(selectedOption && selectedOption.textContent),
          filter_destination_url: safeString(selectedOption && selectedOption.getAttribute('data-collection-url')),
          parent_collection_handle: safeString(filterRoot && filterRoot.getAttribute('data-parent-collection-handle')),
          parent_collection_url: safeString(filterRoot && filterRoot.getAttribute('data-parent-collection-url'))
        });
        return;
      }

      var form = target.closest('[data-sidebar-filter-form]');
      if (!form) return;

      trackBathhouseEvent('collection_filter_apply', {
        filter_name: safeString(target.getAttribute('name')),
        filter_value: safeString(target.value),
        filter_type: safeString(target.type || target.tagName),
        filter_checked: typeof target.checked === 'boolean' ? String(target.checked) : '',
        filter_label: safeString(target.getAttribute('aria-label'))
      });
    }, true);
  }

  function observeSearchFocus() {
    document.addEventListener('focusin', function(event) {
      var input = event.target;
      if (!input || input.tagName !== 'INPUT') return;
      if (safeString(input.getAttribute('name')) !== 'q') return;

      trackBathhouseEvent('search_focus', {
        input_id: safeString(input.id),
        input_classes: safeString(input.className)
      });
    });
  }

  function observeGeneralClickstream() {
    document.addEventListener('click', function(event) {
      var target = event.target && event.target.closest
        ? event.target.closest('a, button, summary, [role="button"], label[for], .accordion__title, .header__logo__link, [data-popdown-toggle], [data-drawer-toggle], [data-accordion-trigger], [data-truncated-holder] button')
        : null;
      if (!target) return;

      if (target.closest('[name="add"], [data-add-to-cart], [data-variant-id]')) return;
      if (target.closest('button[name="checkout"], input[name="checkout"], [href$="/checkout"], .checkout__button')) return;

      var path = safeString(target.getAttribute('href'));
      var urlObject = getUrlObject(path);
      var resolvedPath = safeString(urlObject && urlObject.pathname);
      var properties = getControlProperties(target);

      if (target.matches('.header__logo__link, .header__logo__link *') || (resolvedPath === '/' && target.closest('.header__logo, header, .site-header, [data-header]'))) {
        trackBathhouseEvent('home_logo_click', properties);
        return;
      }

      if (target.hasAttribute('data-drawer-toggle') || properties.control_data_drawer) {
        trackBathhouseEvent('drawer_toggle', properties);
        return;
      }

      if (target.hasAttribute('data-popdown-toggle') || properties.control_data_popdown) {
        trackBathhouseEvent('popdown_toggle', properties);
        return;
      }

      if (target.tagName === 'SUMMARY' || target.hasAttribute('data-accordion-trigger') || target.classList.contains('accordion__title') || target.closest('.accordion__title, .product-accordion, .drawer__accordion')) {
        trackBathhouseEvent('accordion_toggle', properties);
        return;
      }

      if (target.closest('details')) {
        trackBathhouseEvent('details_toggle', properties);
        return;
      }

      if (target.closest('.product-description__actions, .accordion-content__actions, .tab-content__actions, [data-truncated-holder]')) {
        trackBathhouseEvent('read_more_toggle', properties);
        return;
      }

      if (target.getAttribute('role') === 'tab' || target.closest('[role="tablist"], .tabs, .product-tabs')) {
        trackBathhouseEvent('tab_click', properties);
        return;
      }

      if (resolvedPath && /^\/products\/[^/?#]+/.test(resolvedPath)) {
        var searchResult = target.closest('.page-search [data-products-grid] .search__item__generic');
        if (context.pageType === 'search' && searchResult) {
          var searchResults = Array.prototype.slice.call(
            document.querySelectorAll('.page-search [data-products-grid] .search__item__generic')
          );
          var searchResultsCount = Number(context.searchResultsCount);
          properties.search_terms = safeString(context.searchTerms);
          properties.search_results_count = Number.isFinite(searchResultsCount) ? searchResultsCount : null;
          properties.search_result_position = searchResults.indexOf(searchResult) + 1;
          trackBathhouseEvent('search_result_click', properties);
          upgradeSession('search_result_click');
        }

        trackBathhouseEvent('product_link_click', properties);
        return;
      }

      if (resolvedPath && /^\/collections\/[^/?#]+/.test(resolvedPath) && target.closest('.sidebar__item, .sidebar__navigation__list, .sidebar__filter__group')) {
        trackBathhouseEvent('parent_collection_filter_apply', getSidebarProperties(target));
        return;
      }

      if (resolvedPath && /^\/collections\/[^/?#]+/.test(resolvedPath)) {
        trackBathhouseEvent('collection_link_click', properties);
        return;
      }

      if (target.closest('header, .header, .site-header, [data-header]') || target.closest('footer, .site-footer, [data-footer]')) {
        trackBathhouseEvent('navigation_click', properties);
        return;
      }

      if (target.matches('.btn, .button, [role="button"]') || target.closest('.btn, .button, [role="button"]')) {
        trackBathhouseEvent('content_cta_click', properties);
      }
    }, true);
  }

  function observeWebsiteServicesInquiry() {
    var root = document.querySelector('[data-contact-form-context="website-management"]');
    if (!root) return;

    var form = root.querySelector('form');
    if (!form) return;

    var fields = form.querySelectorAll('input:not([type="hidden"]), select, textarea');
    var baseProperties = {
      form_name: 'website_management_inquiry',
      form_context: 'website_management',
      form_section_id: safeString(root.getAttribute('data-section-id')),
      form_field_count: String(fields.length)
    };
    var started = false;
    var pendingStorageKey = 'bathhouse_website_services_pending_submission';

    function createPendingSubmission() {
      var submissionId = window.crypto && typeof window.crypto.randomUUID === 'function'
        ? window.crypto.randomUUID()
        : 'website-services-' + Date.now() + '-' + Math.floor(Math.random() * 1000000);

      try {
        window.sessionStorage.setItem(pendingStorageKey, JSON.stringify({
          id: submissionId,
          created_at: Date.now()
        }));
      } catch (error) {
        return '';
      }

      return submissionId;
    }

    function consumePendingSubmission() {
      var pending = null;

      try {
        pending = JSON.parse(window.sessionStorage.getItem(pendingStorageKey) || 'null');
        window.sessionStorage.removeItem(pendingStorageKey);
      } catch (error) {
        pending = null;
      }

      if (!pending || !safeString(pending.id)) return '';
      if (!Number.isFinite(Number(pending.created_at))) return '';
      if (Date.now() - Number(pending.created_at) > 30 * 60 * 1000) return '';
      return safeString(pending.id);
    }

    function trackStart() {
      if (started) return;
      started = true;
      trackBathhouseEvent('website_services_inquiry_started', baseProperties);
      upgradeSession('website_services_inquiry_started');
    }

    form.addEventListener('focusin', trackStart);
    form.addEventListener('change', trackStart);
    form.addEventListener('submit', function() {
      createPendingSubmission();
      trackBathhouseEvent('website_services_inquiry_submit_attempted', baseProperties);
      upgradeSession('website_services_inquiry_submit_attempted');
    });

    var success = root.querySelector('[data-contact-form-success]');
    if (success) {
      var pendingSubmissionId = consumePendingSubmission();
      if (pendingSubmissionId) {
        trackBathhouseEvent('website_services_inquiry_submitted', baseProperties);
        upgradeSession('website_services_inquiry_submitted');
      }
      if (typeof success.focus === 'function') {
        success.focus();
      }
    }

    var errors = root.querySelector('[data-contact-form-errors]');
    if (errors) {
      consumePendingSubmission();
      var errorCount = Number(errors.getAttribute('data-contact-form-error-count'));
      trackBathhouseEvent('website_services_inquiry_error', {
        form_name: baseProperties.form_name,
        form_context: baseProperties.form_context,
        form_section_id: baseProperties.form_section_id,
        form_field_count: baseProperties.form_field_count,
        form_error_count: Number.isFinite(errorCount) ? String(errorCount) : '1'
      });
      upgradeSession('website_services_inquiry_error');
    }
  }

  function observeScrollDepth() {
    var milestones = [25, 50, 75, 90, 100];
    var ticking = false;

    function evaluateScrollDepth() {
      ticking = false;
      var depth = getScrollDepthPercent();
      if (depth > maxScrollDepth) {
        maxScrollDepth = depth;
      }

      milestones.forEach(function(milestone) {
        if (depth < milestone || trackedScrollMilestones[milestone]) return;
        trackedScrollMilestones[milestone] = true;
        trackBathhouseEvent('scroll_depth', {
          scroll_depth_percent: milestone
        });
      });
    }

    document.addEventListener('scroll', function() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(evaluateScrollDepth);
    }, true);

    evaluateScrollDepth();
  }

  function observePageExit() {
    function handleExit(reason) {
      capturePostHogEvent('bathhouse_page_exit', {
        exit_reason: reason
      });
    }

    window.addEventListener('pagehide', function() {
      handleExit('pagehide');
    });

    document.addEventListener('visibilitychange', function() {
      if (document.visibilityState === 'hidden') {
        handleExit('visibility_hidden');
      }
    });
  }

  document.addEventListener('theme:variant:change', function(event) {
    var variant = event && event.detail ? event.detail.variant : null;
    tagProductContext(variant);
    trackBathhouseEvent('variant_change', {
      selected_variant_id: variant && variant.id ? String(variant.id) : '',
      selected_variant_title: variant && variant.title ? String(variant.title) : '',
      selected_variant_available: variant && typeof variant.available !== 'undefined' ? String(Boolean(variant.available)) : ''
    });
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event && event.detail ? event.detail.cart : null;
    tagCartContext(cart);
    queueCartBridgeSync(cart);
    syncPostHogState();
    trackBathhouseEvent('cart_change', {
      cart_item_count: cart && typeof cart.item_count !== 'undefined' ? String(cart.item_count) : '',
      cart_total_cents: cart && typeof cart.total_price !== 'undefined' ? String(cart.total_price) : ''
    });
    upgradeSession('cart_change');
  });

  document.addEventListener('theme:cart:init', function(event) {
    var cart = event && event.detail ? event.detail.cart : null;
    tagCartContext(cart);
    queueCartBridgeSync(cart);
    syncPostHogState();
  });

  document.addEventListener('DOMContentLoaded', function() {
    initPostHog();
    retryIdentify();
    syncPostHogState();
    capturePostHogPageview();
    applyBaseTags();
    queueCartBridgeSync(null);
    observeSearch();
    observeSearchFocus();
    observeCheckoutIntent();
    observeAddToCartIntent();
    observeCollectionAndFilterIntent();
    observeGeneralClickstream();
    observeWebsiteServicesInquiry();
    observeScrollDepth();
    observePageExit();
    observeJourneyLoopSignals();
  });
})();
